var _path, _ellipse, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgShopping1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1920,
    height: 1080,
    viewBox: "0 0 1920 1080",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1110 1042L1110 1070",
    stroke: "#F2DCCE",
    strokeWidth: 2
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 1110.5,
    cy: 1037.33,
    rx: 16.5,
    ry: 16.3333,
    fill: "#F2DCCE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1107.1 1046C1106.64 1046 1106.24 1045.83 1105.9 1045.5C1105.57 1045.17 1105.4 1044.77 1105.4 1044.3C1105.4 1043.83 1105.57 1043.43 1105.9 1043.1C1106.24 1042.77 1106.64 1042.6 1107.1 1042.6C1107.57 1042.6 1107.97 1042.77 1108.31 1043.1C1108.64 1043.43 1108.81 1043.83 1108.81 1044.3C1108.81 1044.77 1108.64 1045.17 1108.31 1045.5C1107.97 1045.83 1107.57 1046 1107.1 1046ZM1115.61 1046C1115.14 1046 1114.74 1045.83 1114.41 1045.5C1114.08 1045.17 1113.91 1044.77 1113.91 1044.3C1113.91 1043.83 1114.08 1043.43 1114.41 1043.1C1114.74 1042.77 1115.14 1042.6 1115.61 1042.6C1116.08 1042.6 1116.48 1042.77 1116.81 1043.1C1117.15 1043.43 1117.31 1043.83 1117.31 1044.3C1117.31 1044.77 1117.15 1045.17 1116.81 1045.5C1116.48 1045.83 1116.08 1046 1115.61 1046ZM1106.38 1032.4L1108.42 1036.65H1114.38L1116.72 1032.4H1106.38ZM1105.57 1030.7H1118.12C1118.45 1030.7 1118.7 1030.85 1118.87 1031.14C1119.04 1031.43 1119.04 1031.72 1118.89 1032.02L1115.87 1037.46C1115.71 1037.74 1115.5 1037.96 1115.24 1038.12C1114.98 1038.27 1114.69 1038.35 1114.38 1038.35H1108.04L1107.1 1040.05H1117.31V1041.75H1107.1C1106.47 1041.75 1105.98 1041.47 1105.66 1040.91C1105.33 1040.35 1105.32 1039.79 1105.62 1039.24L1106.76 1037.16L1103.7 1030.7H1102V1029H1104.77L1105.57 1030.7Z",
    fill: "#CC7D61"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShopping1);
export default __webpack_public_path__ + "static/media/shopping_1.6e2c9a18b6d93b84150032322fe8e5ce.svg";
export { ForwardRef as ReactComponent };